import * as React from 'react';
import { useState } from 'react';
import { Typography, Card as MuiCard } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Box from "@mui/material/Box";
import {TextFieldOutlinedBlueFocus} from "../components/textField/TextFieldVariants";
import {LightHoverButton} from "../components/button/ButtonVariants";

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    maxWidth: '450px',
    alignItems: 'start',
}));

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError(true);
            setEmailErrorMessage('Bitte geben Sie eine gültige E-Mail Adresse ein.');
            return;
        }

        setEmailError(false);
        setEmailErrorMessage('');

        try {
            const response = await fetch('/api/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setSubmitted(true);
            } else {
                const data = await response.json();
                setEmailError(true);
                setEmailErrorMessage(data.message || 'Ein Fehler ist aufgetreten.');
            }
        } catch (error) {
            setEmailError(true);
            setEmailErrorMessage('Netzwerkfehler. Bitte später erneut versuchen.');
        }
    };

    return (
        <div className={"centered"}>
            <Card variant="outlined">
                <Box
                    width="100%"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h1">
                        Passwort vergessen?
                    </Typography>
                </Box>
                {!submitted ? (
                    <>
                        <TextFieldOutlinedBlueFocus
                            label="E-Mail Adresse"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={emailError}
                            helperText={emailErrorMessage}
                            type="email"
                            fullWidth
                            required
                        />
                        <LightHoverButton type="button" fullWidth onClick={handleSubmit}>
                            Absenden
                        </LightHoverButton>
                    </>
                ) : (
                    <Typography variant="body1" color="success.dark">
                        Falls der User vorhanden ist, wurde eine Mail versendet - bitte schauen Sie in ihr Postfach.
                    </Typography>
                )}
                <Typography variant="body2">
                    <Link
                        to="/login"
                        style={{
                        fontSize: '16px',
                        textDecoration: 'none'}}
                    >
                        Zurück zum Login
                    </Link>
                </Typography>
            </Card>
        </div>
    );
}